import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "schedule-section mt-2" }
const _hoisted_2 = { class: "customer-card" }
const _hoisted_3 = { class: "customer-row" }
const _hoisted_4 = { class: "customer-avatar" }
const _hoisted_5 = { class: "customer-copy" }
const _hoisted_6 = { class: "customer-name" }
const _hoisted_7 = { class: "customer-meta" }
const _hoisted_8 = { class: "customer-meta" }
const _hoisted_9 = { class: "summary-actions" }
const _hoisted_10 = ["href"]
const _hoisted_11 = ["href"]

import { computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AppointmentCustomerInfoCard',
  props: {
    customerInfo: {}
  },
  setup(__props: any) {

const props = __props;

const customerEmailHref = computed(() => {
  const email = props.customerInfo?.email?.trim();
  return email ? `mailto:${email}` : "";
});

const customerPhoneHref = computed(() => {
  const phone = props.customerInfo?.phone_no?.trim();
  return phone ? `tel:${phone}` : "";
});

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_avatar = _resolveComponent("v-avatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "px-2" }, [
      _createElementVNode("p", { class: "schedule-section-title" }, "Customer Details")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_v_avatar, { size: "40" }, {
            default: _withCtx(() => [
              (__props.customerInfo?.avatar)
                ? (_openBlock(), _createBlock(_component_v_img, {
                    key: 0,
                    src: __props.customerInfo.avatar,
                    alt: __props.customerInfo.name || 'Customer avatar',
                    cover: ""
                  }, null, 8, ["src", "alt"]))
                : (_openBlock(), _createBlock(_component_v_icon, {
                    key: 1,
                    size: "18"
                  }, {
                    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                      _createTextVNode("mdi-account", -1)
                    ]))]),
                    _: 1
                  }))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", _hoisted_6, _toDisplayString(__props.customerInfo?.name || "-"), 1),
          _createElementVNode("p", _hoisted_7, [
            _createVNode(_component_v_icon, { size: "14" }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode("mdi-phone-outline", -1)
              ]))]),
              _: 1
            }),
            _createElementVNode("span", null, _toDisplayString(__props.customerInfo?.phone_no || "-"), 1)
          ]),
          _createElementVNode("p", _hoisted_8, [
            _createVNode(_component_v_icon, { size: "14" }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode("mdi-email-outline", -1)
              ]))]),
              _: 1
            }),
            _createElementVNode("span", null, _toDisplayString(__props.customerInfo?.email || "-"), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("a", {
          class: _normalizeClass(["summary-action", { 'summary-action--disabled': !customerEmailHref.value }]),
          href: customerEmailHref.value || undefined
        }, [
          _createVNode(_component_v_icon, {
            size: "18",
            color: "deep-orange-darken-1"
          }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode("mdi-email-outline", -1)
            ]))]),
            _: 1
          }),
          _cache[4] || (_cache[4] = _createElementVNode("span", null, "Email", -1))
        ], 10, _hoisted_10),
        _createElementVNode("a", {
          class: _normalizeClass(["summary-action summary-action--split", { 'summary-action--disabled': !customerPhoneHref.value }]),
          href: customerPhoneHref.value || undefined
        }, [
          _createVNode(_component_v_icon, {
            size: "18",
            color: "deep-orange-darken-1"
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createTextVNode("mdi-phone-outline", -1)
            ]))]),
            _: 1
          }),
          _cache[6] || (_cache[6] = _createElementVNode("span", null, "Call", -1))
        ], 10, _hoisted_11)
      ])
    ])
  ]))
}
}

})